import React, { useEffect } from 'react'
import { AutoComplete, InputLabeledContainer, GCheckBox, Select, PercentageInput } from 'tennders-common/form/components'
import TextInput from 'tennders-common/form/components/new-inputs/TextInput'
import SingleDatePicker from 'tennders-common/form/components/new-inputs/SingleDatePicker'
import { apiGet } from 'tennders-stracture/libs/api'
import { INPUT_CHARACTER_LIMITS } from 'tennders-stracture/libs/constants'
import usePermissions from 'tennders-auth/hooks/usePermissions'
import { FINANCE_MODULE_INVOICE_OVERRIDE_RULES } from 'tennders-stracture/libs/permissions'
import SearchableSelect from 'tennders-common/form/components/new-inputs/SearchableSelect'
import useTranslation from 'next-translate/useTranslation'

const dataExtractor = (data) => data.items.map((item) => ({ ...item, label: item.name }))
let defaultVat = null
const requestBuilder = ({ keyword, options }) => apiGet(
  '/companies',
  {
    ...options,
    params: {
      query: keyword,
      attributes: '{id, name,preferences, paymentTerms{id, days, type{name}}'
    }
  },
  true
)

const MultipleCostInvoiceGeneralInfo = (props) => {
  const {
    form,
    formErrors,
    onCompanyChange,
    onChange,
    onDateOfReceiptChange,
    onPaymentTermChange,
    onDueDateChange,
    selectedTransaction,
    company,
    allPaymentTerms,
    editDisabled,
    fetchCostInvoices,
    costInvoices
  } = props
  const { ableTo } = usePermissions()
  const { t } = useTranslation()

  useEffect(() => {
    if (form.reversedVat) {
      defaultVat = form.defaultVat
      onChange('defaultVat', null)
    } else {
      onChange('defaultVat', defaultVat)
    }
  }, [form.reversedVat])

  return (
    <>
      <div className="w-30">
        { (form.id || selectedTransaction?.id || form.draftId) && company && !ableTo(FINANCE_MODULE_INVOICE_OVERRIDE_RULES)
          ? (
            <InputLabeledContainer
              name="company"
              label="Company Name"
              errors={formErrors}
              className="mb-10"
              defaultText={company.name}
              renderInput={(rest) => (
                <TextInput
                  {...rest}
                  defaultValue={company.name}
                  className="form-input small"
                  disabled
                />
              )}
            />
          )
          : (
            <InputLabeledContainer
              name="company"
              form={form}
              label="Company Name"
              errors={formErrors}
              className="d-flex flex-col pos-rel"
              onChange={(k, v) => onCompanyChange(v)}
              renderInput={(rest) => (
                <AutoComplete
                  {...rest}
                  requestBuilder={requestBuilder}
                  dataExporter={dataExtractor}
                  value={company?.name || form.company}
                  className="form-input small"
                  disabled={editDisabled}

                />
              )}
            />
          )}
        {(!form.id || form.creditNote) && (
          <div className="d-flex row justify-space">
            <GCheckBox
              name="creditNote"
              eClass="d-flex row align-center mt-24 mb-20"
              label="Apply As Credit Note"
              value={form?.creditNote}
              onSet={(visible) => onChange('creditNote', visible)}
            />
            {form.creditNote && (
              <InputLabeledContainer
                label={t('costInvoice:select_cost_invoice')}
                form={form}
                name="creditNoteFor"
                className="mb-10 w-50"
                errors={formErrors}
                onChange={onChange}
                renderInput={(rest) => (
                  <SearchableSelect
                    fetchItems={() => fetchCostInvoices(company?.id)}
                    options={costInvoices}
                    labelKey="label"
                    valueKey="value"
                    label={t('costInvoice:select_cost_invoice')}
                    disabled={!company?.id}
                    {...rest}
                  />
                )}
              />
            )}
          </div>
        )}
        <InputLabeledContainer
          label={form.creditNote ? 'Credit Note Number' : 'Invoice Number'}
          errors={formErrors}
          name="invoiceNo"
          className="mb-10"
          onChange={onChange}
          form={form}
          renderInput={(props) => (
            <TextInput
              className="form-input small"
              {...props}
              maxLength={INPUT_CHARACTER_LIMITS.INVOICE_NO}
              disabled={editDisabled}
            />
          )}
        />
      </div>
      <div className="w-30">
        <InputLabeledContainer
          label="Issue Date"
          form={form}
          errors={formErrors}
          name="dateOfIssue"
          className="mb-10"
          onChange={onChange}
          renderInput={(props) => (
            <SingleDatePicker
              className="form-input small"
              {...props}
              disabled={editDisabled}
            />
          )}
        />
        <InputLabeledContainer
          label="Payment Term"
          form={form}
          name="paymentTerm"
          className="mb-10"
          errors={formErrors}
          onChange={onPaymentTermChange}
          renderInput={(props) => (
            <Select
              items={allPaymentTerms}
              className="form-select small"
              {...props}
              disabled={editDisabled}
            />
          )}
        />
        <InputLabeledContainer
          label="Due date"
          name="dueDate"
          className="mb-10"
          form={form}
          onChange={(k, v) => onDueDateChange(v)}
          errors={formErrors}
          renderInput={(props) => (
            <SingleDatePicker
              className="form-input small"
              {...props}
              disabled={editDisabled}
            />
          )}
        />
      </div>
      <div className="w-30">
        <InputLabeledContainer
          label="Reception date"
          name="dateOfReceipt"
          form={form}
          errors={formErrors}
          className="mb-10"
          onChange={onDateOfReceiptChange}
          renderInput={(props) => (
            <SingleDatePicker
              className="form-input small"
              {...props}
            />
          )}
        />
        <InputLabeledContainer
          label="IRPF"
          errors={formErrors}
          name="irpf"
          className="mb-10"
          form={form}
          onChange={onChange}
          renderInput={(props) => (
            <PercentageInput
              className="form-input small"
              {...props}
              value={form.irpf || null}
              disabled={editDisabled}
            />
          )}
        />
        <InputLabeledContainer
          label="Vat Percentage"
          name="defaultVat"
          className="mb-10"
          form={form}
          onChange={onChange}
          errors={formErrors}
          renderInput={(props) => (
            <PercentageInput
              className="form-input smaller w-auto"
              {...props}
              value={form.defaultVat || null}
              disabled={editDisabled}
            />
          )}
        />
        <div className="mb-10">
          <GCheckBox
            readOnly={editDisabled}
            name="reversedVat"
            eClass="d-flex row align-center mt-24"
            label="VAT reverse charge"
            value={form?.reversedVat}
            onSet={(visible) => onChange('reversedVat', visible)}
          />
        </div>
      </div>
    </>
  )
}

export default React.memo(MultipleCostInvoiceGeneralInfo)
